import React from 'react'
import { Image } from 'react-native'

import { images } from '@zet/assets'
import { MotiView } from '@zet/common/components/motiView'
import { MY_TEAMS_ADVISOR } from '@zet/constants'
import useStore from '@zet/customer/src/store'
import { Stack } from '@zet/design-system/layout'
import Pressable from '@zet/design-system/pressable'
import { B5, CTN, SH2 } from '@zet/design-system/typography'
import { APP_NAME } from '@zet/end-points'
import { i18n } from '@zet/localization'
import { Categories } from '@zet/utils/Constants'
import { navigateTo } from '@zet/utils/navigation'
import { LinearGradient } from 'expo-linear-gradient'

import CreditBuilderBg from '../../assets/svg/guaranteedBg.svg'
import RupayCardBg from '../../assets/svg/rupayCardBg.svg'
import SellAndWinBg from '../../assets/svg/sellAndWin.svg'
import { CBMLogoUrl } from '../../utils/constants'
import hingeContent from './constants'

export interface ICategoryCard {
  id: number
  title: string
  subtitle: string
  onCategoryPress?: (() => void) | null
  keyIndex: number
  svgIcon: React.ReactNode
  onInitialCategoryPress?: () => void | null
}

const CategoryCard: React.FC<ICategoryCard> = ({
  id,
  title,
  subtitle,
  onCategoryPress,
  keyIndex,
  svgIcon,
  onInitialCategoryPress,
}) => {
  const navigate = navigateTo
  const { setSelectedCustomer } = useStore((state) => state)

  const onPress = () => {
    onInitialCategoryPress && onInitialCategoryPress()
    setSelectedCustomer(null)
    id === 18 && APP_NAME !== MY_TEAMS_ADVISOR
      ? navigate('MagnetBenefits')
      : id === 25 && APP_NAME !== MY_TEAMS_ADVISOR
      ? navigate('CreditBuilderLoans')
      : id === 21
      ? navigate('ZetReferral')
      : id === 26 && APP_NAME !== MY_TEAMS_ADVISOR
      ? navigate('ZetStore')
      : navigate('BrandPage', {
          categories: title,
          routeName: 'category',
          categoryId: id,
        })
    onCategoryPress && onCategoryPress()
  }

  const getCategoryIcon = () => {
    if (id === Categories.ZET_STORE)
      return (
        <Image
          source={require('../../assets/images/zet_store.png')}
          resizeMode="contain"
          className="h-[45] w-[45]"
        />
      )
    if (id === 18)
      return (
        <Image
          source={images.sbmLogo}
          resizeMode="contain"
          className="h-[45] w-[45]"
        />
      )
    if (id === 25)
      return (
        <Image
          source={{
            uri: CBMLogoUrl,
          }}
          resizeMode="contain"
          className="h-[45] w-[45]"
        />
      )
    return svgIcon
  }

  const getHingeBackground = () => {
    const iconName = hingeContent[id]?.svg

    switch (iconName) {
      case 'RupayCard':
        return <RupayCardBg />
      case 'creditBuilder':
        return <CreditBuilderBg />
      case 'SellAndWin':
        return <SellAndWinBg />
    }
  }

  return (
    <Pressable
      opacity
      className="h-40 items-center"
      style={{
        margin: 6,
        width: '47%',
        borderRadius: 8,
      }}
      onPress={onPress}
    >
      <MotiView
        className={`border-grays-40 h-full w-full items-center justify-center border py-3 ${
          id === 21 ? 'bg-decorative-coolPurple10' : ''
        }`}
        from={{ opacity: 0, translateY: 50 }}
        animate={{ opacity: 1, translateY: 0 }}
        transition={{ delay: keyIndex * 100 }}
        style={{
          borderRadius: 8,
        }}
      >
        {hingeContent.hasOwnProperty(id) && hingeContent[id]?.show ? (
          <>
            <Stack
              style={{
                top: -1,
              }}
              className="absolute top-0"
            >
              {getHingeBackground()}
            </Stack>
            <CTN
              style={{
                top: -1,
              }}
              className={`absolute top-0 font-[Graphie-Bold] text-white`}
            >
              {hingeContent[id]?.text}
            </CTN>
          </>
        ) : null}
        <Stack
          className={`${hingeContent.hasOwnProperty(id) ? 'mt-2' : ''} mb-1`}
        >
          {getCategoryIcon()}
        </Stack>
        <SH2 className="text-grays-80 py-2 text-center">{title}</SH2>
        {subtitle && APP_NAME !== MY_TEAMS_ADVISOR && (
          <B5 className="text-grays-60 px-3">{subtitle}</B5>
        )}
      </MotiView>
      {id === 21 && (
        <LinearGradient
          colors={['#E9AA39', '#FCE491']}
          start={[1, 0]}
          end={[0, 0]}
          className="-mt-3 self-center rounded-lg px-2 py-1"
        >
          <B5>{i18n.t('categories.noCheck')}</B5>
        </LinearGradient>
      )}
    </Pressable>
  )
}

export default CategoryCard
